<template>
  <div :key="key">
    <div v-if="from === 'editor'">
      <div v-if="isOpen">
        <!-- <textarea :id="'commentText' + '-' + fromGroup + '-' + id" placeholder="Enter your comment here" class="mb-2 mr-sm-2 mb-sm-0 mt-4 form-control"></textarea> -->
        <vue-editor v-model="content" :editorToolbar="customToolbar" />
        <button
          type="button"
          class="btn btn-light btn-block"
          @click="addComment()"
        >
          Add Comment
        </button>
      </div>
      <div v-if="!isOpen">
        <div class="alert alert-light">
          <div style="display: flex; justify-content: space-between">
            <span
              style="width: 90%; word-wrap: break-word"
              :id="'commentText' + '-' + fromGroup + '-' + id"
            ></span>
            <div class="block-options-item" @click="deleteComment()">
              <a type="button" class="btn btn-light" ref="tooltiphide">
                <i class="fa fa-minus text-primary-dark"></i>
              </a>
            </div>
            <div class="block-options-item" @click="editComment()">
              <a type="button" class="btn btn-light" ref="tooltiphide">
                <i class="fa fa-edit text-primary-dark"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="from === 'preview'">
      <div :id="'commentText' + '-' + fromGroup + '-' + id"></div>
    </div>
  </div>
</template>
<script>
import { VueEditor } from "vue2-editor";
import $ from "jquery";
import { mapMutations, mapState } from "vuex";

export default {
  name: "Comment",
  props: ["comment", "fromGroup", "id", "from"],
  components: { VueEditor },
  data: function () {
    return {
      isOpen: false,
      content: this.comment,
      key: 1,
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ["clean"],
      ],
    };
  },
  mounted() {
    $(`#commentText-${this.fromGroup}-${this.id}`).append(this.comment);
  },
  watch: {
    currentField(val) {
      if (val[0].type === "commentWidget") {
        val[0].title = val.filter((x) => x.group === this.fromGroup)[0].title;
      } else {
        val.map((item) => {
          if (item.type === "commentWidget") {
            item.title = {
              en: "Comment",
              nl: "Comment",
            };
          }
        });
      }
    },
  },
  methods: {
    ...mapMutations({
      setTrigger: "forms/SET_TRIGGER",
    }),
    currentField1() {
      let arrayFields = this.form.data.fields.filter((x) => Array.isArray(x));
      let field = {};
      arrayFields.map((a) => {
        if (a.filter((y) => y.group === this.fromGroup)[0]) {
          field = a;
        }
      });
      return field;
    },
    addComment() {
      this.currentCommentField.comment = this.content;
      this.isOpen = false;
      setTimeout(() => {
        $(`#commentText-${this.fromGroup}-${this.id}`).append(this.content);
      }, 100);
    },
    deleteComment() {
      let current = this.currentField1();
      current.map((item, index) => {
        if (item.id === this.id && item.type === "commentWidget") {
          current.splice(index, 1);
          this.$forceUpdate();
          this.setTrigger(!this.trigger);
        }
      });
    },
    editComment() {
      this.isOpen = true;
      // setTimeout(() => {
      //     document.getElementById('commentText' + '-' + this.fromGroup + '-' + this.id).value = this.comment
      // },100)
    },
  },
  computed: {
    ...mapState({
      trigger: (state) => state.forms.trigger,
    }),
    currentCommentField() {
      let arrayFields = this.form.data.fields.filter((x) => Array.isArray(x));
      let field = {};
      arrayFields.map((a) => {
        if (
          a.filter(
            (y) =>
              y.type === "commentWidget" &&
              y.fromGroup === this.fromGroup &&
              y.id === this.id
          )[0]
        ) {
          field = a.filter(
            (y) =>
              y.type === "commentWidget" &&
              y.fromGroup === this.fromGroup &&
              y.id === this.id
          )[0];
        }
      });
      return field;
    },
    currentField() {
      let arrayFields = this.form.data.fields.filter((x) => Array.isArray(x));
      let field = {};
      arrayFields.map((a) => {
        if (a.filter((y) => y.group === this.fromGroup)[0]) {
          field = a;
        }
      });
      return field;
    },
  },
};
</script>
<style>
@import "~vue2-editor/dist/vue2-editor.css";

.ql-align-center {
  text-align: center;
}
.ql-align-right {
  text-align: right;
}
</style>
